angular.module("env.customConfig.reports", [
    "env.customConfig.provider",
    "env.customConfig.logicResolvers",
    "env.custom.customModule"
])
    .config(function ($customisationConfigProvider, $customLogicResolversProvider, gettext) {

        $customisationConfigProvider.reports =
            [
                {
                    name: "order-label",
                    options: [
                        {
                            value: {
                                name: 'Order Label',
                                reportFileName: 'OrderLabel.repx',
                                buttonImageResourceName: 'smallReportIcon',
                                baseEntityName: "OrderItem",
                                requiresSelection: true
                            }
                        }
                    ]
                },
                {
                    name: "order-pair-label",
                    options: [
                        {
                            value: {
                                name: 'Order Pair Labels',
                                reportFileName: 'OrderPairLabels.repx',
                                buttonImageResourceName: 'smallReportIcon',
                                baseEntityName: "OrderItem",
                                requiresSelection: true
                            }
                        }
                    ]
                },
                {
                    name: "order-report",
                    resolve: function (context) {
                        //context object for login-screen-band will be of the form: { user: %currentUserObject% }
                        return {
                            name: 'Customer Prescription Copy',
                            reportFileName: 'OrderDetail.repx',
                            buttonImageResourceName: 'smallReportIcon',
                            baseEntityName: "OrderItem",
                            requiresSelection: true
                        };
                    }
                },
                {
                    name: "lab-order-report",
                    resolve: function (context) {
                        //context object for login-screen-band will be of the form: { user: %currentUserObject% }
                        return {
                            name: 'Laboratory Prescription Copy',
                            reportFileName: 'LabOrderDetail.repx',
                            buttonImageResourceName: 'smallReportIcon',
                            baseEntityName: "OrderItem",
                            requiresSelection: true
                        };
                    }
                },
                {
                    name: "orders-report-general",
                    options: [
                        {
                            value: {
                                name: gettext("Show Orders Report"),
                                reportFileName: "OrderItems.repx",
                                buttonImageResourceName: "smallReportIcon",
                                baseEntityName: "OrderItem"
                            },
                            condition: function (context) {
                                return true;
                            }
                        }
                    ]
                },
                {
                    name: "order-report-barcodes",
                    options: [
                        {
                            value: {
                                name: 'Order Report + Barcodes',
                                reportFileName: 'OrderDetail.B.Barcodes.repx',
                                buttonImageResourceName: 'smallReportIcon',
                                baseEntityName: "OrderItem",
                                requiresSelection: true
                            }
                        }
                    ]
                },
                {
                    name: "order-report-smaller",
                    options: [
                        {
                            value: {
                                name: 'Order Report - Smaller',
                                reportFileName: 'OrderDetail.B.Smaller.repx',
                                buttonImageResourceName: 'smallReportIcon',
                                baseEntityName: "OrderItem",
                                requiresSelection: true
                            }
                        }
                    ]
                }, 
                {
                    name: "order-certificate",
                    options: [
                        {
                            value: {
                                name: 'Order Certificate',
                                reportFileName: 'OrderCertificate.repx',
                                buttonImageResourceName: 'smallReportIcon',
                                baseEntityName: "OrderItem",
                                requiresSelection: true
                            }
                        }
                    ]
                },
                {
                    name: "show-audit",
                    options: [
                        {
                            value: {
                                name: gettext("Show Audit"),
                                reportFileName: "Audit.repx",
                                buttonImageResourceName: "smallReportIcon",
                                baseEntityName: "WorkflowAudit"
                            },
                            condition: function (context) {
                                //return context.user && context.user.role && context.user.role.isCentre;
                                return true;
                            }
                        }
                    ]
                },
                {
                    name: "multi-orders",
                    options: [
                        {
                            value: {
                                name: gettext("Orders Report"),
                                reportFileName: "OrdersReport.repx",
                                buttonImageResourceName: "smallReportIcon",
                                baseEntityName: "OrderItem"
                            },
                            condition: function (context) {
                                return true;
                            }
                        }
                    ]
                },
                {
                    name: "daily-report",
                    options: [
                        {
                            value: {
                                name: gettext("Daily Report"),
                                reportFileName: "DailyReport.repx",
                                buttonImageResourceName: "smallReportIcon",
                                baseEntityName: "OrderItem"
                            },
                            condition: function (context) {
                                return true;
                            }
                        }
                    ]
                },
                {
                    name: "orders-by-customer",
                    options: [
                        {
                            value: {
                                name: gettext("Orders by Customer"),
                                reportFileName: "OrdersbyCustomer.repx",
                                buttonImageResourceName: "smallReportIcon",
                                baseEntityName: "OrderItem"
                            },
                            condition: function (context) {
                                return true;
                            }
                        }
                    ]
                },
                {
                    name: "orders-by-date",
                    options: [
                        {
                            value: {
                                name: gettext("Ordering Stats (1 year)"),
                                reportFileName: "OrdersCountByDate.repx",
                                query: function (gridQuery, selectedItem) {

                                    function pad(number) {
                                        return number < 10 ? "0" + number : number;
                                    }

                                    //We want the report to show items for the previous 12 months
                                    var today = new Date();
                                    var from = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate());

                                    var oneYearAgo = from.toISOStringUTC();
                                    var todayDayString = today.toISOStringUTC();

                                    return "OrderItem.Deleted = false AND OrderItem.Created >= #" + oneYearAgo + "# AND OrderItem.Created <= #" + todayDayString + "#";
                                },
                                buttonImageResourceName: "smallReportIcon",
                                baseEntityName: "OrderItem"
                            },
                            condition: function (context) {
                                return true;
                            }
                        }
                    ]
                },
                {
                    name: "orders-by-date-2yrs",
                    options: [
                        {
                            value: {
                                name: gettext("Ordering Stats (2 years)"),
                                reportFileName: "OrdersCountByDate.repx",
                                query: function (gridQuery, selectedItem) {

                                    function pad(number) {
                                        return number < 10 ? "0" + number : number;
                                    }

                                    //We want the report to show items for the previous 12 months
                                    var today = new Date();
                                    var from = new Date(today.getFullYear() - 2, today.getMonth(), today.getDate());

                                    var oneYearAgo = from.toISOStringUTC();
                                    var todayDayString = today.toISOStringUTC();

                                    return "OrderItem.Deleted = false AND OrderItem.Created >= #" + oneYearAgo + "# AND OrderItem.Created <= #" + todayDayString + "#";
                                },
                                buttonImageResourceName: "smallReportIcon",
                                baseEntityName: "OrderItem"
                            },
                            condition: function (context) {
                                return true;
                            }
                        }
                    ]
                },
                {
                    name: "orders-by-mid-layer",
                    options: [
                        {
                            value: {
                                name: gettext("Orders by Mid-Layer"),
                                reportFileName: "OrdersbyMidLayer.repx",
                                query: function (gridQuery, selectedItem) {

                                    function pad(number) {
                                        return number < 10 ? "0" + number : number;
                                    }

                                    //We want the report to show items for the previous 6 months, excluding current month
                                    var today = new Date();
                                    var from = new Date(today.getFullYear(), today.getMonth() - 6, 1);

                                    var oneMonthsAgo = from.toISOStringUTC();
                                    var todayDayString = today.toISOStringUTC();

                                    return "OrderItem.Deleted = false AND OrderItem.Created >= #" + oneMonthsAgo + "# AND OrderItem.Created <= #" + todayDayString + "#";
                                },
                                orderBy: "Id ASC",
                                buttonImageResourceName: "smallReportIcon",
                                baseEntityName: "OrderItem"
                            },
                            condition: function (context) {
                                return true;
                            }
                        }
                    ]
                },
                {
                    name: "overnight-orders-overview",
                    options: [
                        {
                            value: {
                                name: gettext("Overnight Orders Overview"),
                                reportFileName: "OvernightOrders.repx",
                                query: function (gridQuery, selectedItem) {

                                    function pad(number) {
                                        return number < 10 ? "0" + number : number;
                                    }

                                    //We want to take for analysis orders during last week, however it is safer to take a bit more
                                    //in case it is Monday morning and we want to take into analysis orders from weekend
                                    var from = new Date();
                                    from.setDate(from.getDate() - 10); //To be able to look back 5 working days ago starting from monday, we need to have 10 days back history
                                    from.setHours(15, 0, 0, 0);

                                    var weekAgo = from.toISOStringUTC();
                                    
                                    return "OrderItem.Deleted = false AND Step.Code <> 'Cancelled' AND Step.Code <> 'CreateFailed' AND OrderItem.Created >= #" + weekAgo + "#";
                                },
                                buttonImageResourceName: "smallReportIcon",
                                baseEntityName: "OrderItem"
                            },
                            condition: function (context) {
                                return true;
                            }
                        }
                    ]
                },
                {
                    name: "orders-month-overview",
                    options: [
                        {
                            value: {
                                name: gettext("Month Overview"),
                                reportFileName: "OrdersMonthOverview.repx",
                                query: function (gridQuery, selectedItem) {
                                    function pad(number) {
                                        return number < 10 ? "0" + number : number;
                                    }

                                    //We want the report to show items for the previous 6 months, excluding current month
                                    var today = new Date();
                                    var from = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());

                                    var oneMonthsAgo = from.toISOStringUTC();
                                    var todayDayString = today.toISOStringUTC();

                                    return "OrderItem.Deleted = false AND Step.Code <> 'Cancelled' AND Step.Code <> 'CreateFailed' AND OrderItem.Created >= #" + oneMonthsAgo + "# AND OrderItem.Created <= #" + todayDayString + "#";
                                },
                                buttonImageResourceName: "smallReportIcon",
                                baseEntityName: "OrderItem"
                            },
                            condition: function (context) {
                                return true;
                            }
                        }
                    ]
                },
                //{
                //    name: "orders-report-fixed-query1",
                //    options: [
                //        {
                //            value: {
                //                name: gettext("Show Particular Items Report"),
                //                reportFileName: "OrderItemsFixed.repx",
                //                buttonImageResourceName: "smallReportIcon",
                //                query: "OrderItem.Deleted = false AND Step.Code = 'Scan'", //Any OMQL query here, Optional parameter
                //                orderBy: "Id ASC",
                //                baseEntityName: "OrderItem"
                //            },
                //            condition: function (context) {
                //                return true;
                //            }
                //        }
                //    ]
                //},
                //{
                //    name: "orders-by-customer-one-month",
                //    options: [
                //        {
                //            value: {
                //                name: gettext("Orders by Customer (1 Year)"),
                //                reportFileName: "Orders by Customer.repx",
                //                buttonImageResourceName: "smallReportIcon",
                //                query: function (gridQuery, selectedItem) {

                //                    function pad(number) {
                //                        if (number < 10) {
                //                            return '0' + number;
                //                        }
                //                        return number;
                //                    }
                //                    var today = new Date();
                //                    today.setFullYear(today.getFullYear() - 1);
                //                    var todayUtc = new Date(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate(), today.getUTCHours(), today.getUTCMinutes(), today.getUTCSeconds());

                //                    var oneYearAgo = todayUtc.toISOStringUTC();

                //                    return "OrderItem.Deleted = false AND OrderItem.Created > #" + oneYearAgo + "#";
                //                },
                //                orderBy: "Created ASC",
                //                baseEntityName: "OrderItem"
                //            },
                //            condition: function (context) {
                //                return context.user && context.user.role && context.user.role.isCentre;
                //            }
                //        }
                //    ]
                //}
            ];
    })
;
